
const initializers = {
  version: "2.0.0",
  api_host: "https://app.astrnt.co",
  api_host_v2: "https://app-v2.astrnt.co",
};

export default initializers;
